var _defs, _path, _path2, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEclipseColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 2344,
    viewBox: "0 0 256 240",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1089.396%",
    x2: "50%",
    y2: "-159.5%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473788",
    offset: "30.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2255",
    offset: "87.2%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.999%",
    y1: "896.537%",
    x2: "49.999%",
    y2: "-352.359%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473788",
    offset: "30.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2255",
    offset: "87.2%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.999%",
    y1: "215.17%",
    x2: "49.999%",
    y2: "-166.715%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#473788",
    offset: "30.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2255",
    offset: "86.31%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.382 153.049H31.26c5.18 17.768 14.792 33.693 28.864 47.768 22.434 22.436 49.41 33.64 80.956 33.64 6.306 0 12.416-.47 18.35-1.365 23.761-3.587 44.565-14.33 62.39-32.275 14.162-14.07 23.842-30 29.062-47.768H70.382zM48.81 99.915H28.373a119.493 119.493 0 0 0-1.488 13.775h228.399c-.233-4.7-.743-9.285-1.497-13.775M26.885 126.482c.231 4.703.738 9.287 1.488 13.775h225.418a118.86 118.86 0 0 0 1.5-13.775M250.887 87.12c-5.215-17.817-14.897-33.817-29.067-47.99-17.778-17.777-38.522-28.443-62.207-32.031a123.318 123.318 0 0 0-18.532-1.386c-31.546 0-58.524 11.143-80.956 33.418C46.048 53.303 36.43 69.303 31.254 87.12",
    fill: "#2C2255"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.093 120.09C20.093 59.753 65.407 9.621 124.357.803c-1.462-.053-2.932-.112-4.409-.112C53.796.692.164 54.15.164 120.09c0 65.943 53.63 119.397 119.784 119.397 1.482 0 2.951-.056 4.419-.11-58.96-8.817-104.274-58.95-104.274-119.287z",
    fill: "#F7941E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M155.728 14.226A77.824 77.824 0 0 0 153.364.451H2.642A77.753 77.753 0 0 0 .276 14.226h155.452z",
    fill: "url(#a)",
    transform: "translate(63.083 99.461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.728 27.02H.278a77.611 77.611 0 0 0 2.364 13.776h150.724a77.821 77.821 0 0 0 2.362-13.776z",
    fill: "url(#b)",
    transform: "translate(63.083 99.461)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.003 98.636c31.3 0 58.282-18.441 70.706-45.048H7.297c12.425 26.607 39.405 45.048 70.706 45.048z",
    fill: "url(#c)",
    transform: "translate(63.083 99.461)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.84 126.482h203.29c.108-2.035.168-4.084.168-6.147 0-2.232-.081-4.444-.208-6.647H26.885c-.126 2.2-.208 4.415-.208 6.647 0 2.063.06 4.112.168 6.147H51.84zM69.924 87.12H31.252c-1.271 4.166-2.091 8.44-2.879 12.795H253.065a113.52 113.52 0 0 0-3.075-12.795M238.373 140.255H28.371c.766 4.352 1.638 8.623 2.888 12.794H250.738a113.252 113.252 0 0 0 3.023-12.794h-15.388z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipseColor);
export default __webpack_public_path__ + "static/media/eclipse-color.930aaf4f6a57da34c5080476c4cd2612.svg";
export { ForwardRef as ReactComponent };